import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import {
  decrementOffset,
  incrementOffset,
  toggleOffsetView
} from '../../duck/operations'

import states from '../../lib/states'

import Image from '../shared/image'
import { Button } from '../shared/button'

import DoneSvg from '../../assets/icons/done.svg'
import MinusSvg from '../../assets/icons/minus.svg'
import PlusSvg from '../../assets/icons/plus.svg'

const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 40%;
  position: relative;
  background: #ffffff;
  margin-top: 28px;
`

const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Offset = styled.div`
  font-size: 16px;
  min-width: 80px;
  font-family: DroidSansMono, Courier;
  letter-spacing: -0.7px
  text-align: center;
`

const DoneIcon = styled(Image).attrs({
  src: DoneSvg,
  alt: ''
})`
  margin-right: 4px;
  width: 9px;
`

const StepperIcon = styled(Image).attrs({
  alt: ''
})`
  border: 1px solid #00b4fe;
  border-radius: 50%;
  padding: 5px;
  &:hover {
    border-color: ${props => props.status !== states.AUTOSYNC ? 'rgba(0, 180, 254, 0.4)' : '#00b4fe'};
  }
  &:active {
    border-color: ${props => props.status !== states.AUTOSYNC ? 'rgba(0, 180, 254, 1)' : '#00b4fe'};
  }
`

const MinusIcon = styled(StepperIcon).attrs({
  src: MinusSvg
})``

const PlusIcon = styled(StepperIcon).attrs({
  src: PlusSvg
})``

const SAMPLES_PER_AAC_FRAME = 1024
const EXPECTED_SAMPLE_RATE = 44100
const AAC_FRAME_DURATION_MS = SAMPLES_PER_AAC_FRAME / EXPECTED_SAMPLE_RATE * 1000
const OLD_PLAYER_OFFSET_MS = Math.round(10 * AAC_FRAME_DURATION_MS) // new player is 10 frames faster than old player

const ManualOffsetComponent = (props) => {
  return (
    <Main>
      <StepperContainer>
        <MinusIcon
          status={props.status}
          onClick={
            props.status === states.AUTOSYNC
              ? ()=>{}
              : props.decrementOffset
          }
        />
        <Offset> {
          props.status === states.AUTOSYNC
            ? '--'
            : props.offset + OLD_PLAYER_OFFSET_MS
        }
        </Offset>
        <PlusIcon
          status={props.status}
          onClick={
            props.status === states.AUTOSYNC
              ? ()=>{}
              : props.incrementOffset
          }
        />
      </StepperContainer>
      <Button onClick={props.toggleOffsetView}>
        <DoneIcon />Done
      </Button>
    </Main>
  )
}

const mapStateToProps = (state) => {
  return {
    offset: state.offset,
    status: state.status
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators( { decrementOffset, incrementOffset, toggleOffsetView }, dispatch)
}

export const ManualOffset = connect(mapStateToProps, mapDispatchToProps)(ManualOffsetComponent)



// WEBPACK FOOTER //
// ./src/components/player/manualOffset.js